export function calculateGrossPrice(netPrice: number, markupPercent: number): number {
  return Math.ceil(netPrice * (1 + markupPercent / 100));
}

export interface MarkupRule {
  markup_percent: number;
  provider_id: string | null;
  experience_id: string | null;
}

/**
 * Resolve the best markup rule: experience-specific > provider-specific > global default
 */
export function resolveMarkup(
  rules: MarkupRule[],
  experienceId: string,
  providerId: string
): number {
  const experienceRule = rules.find(
    (r) => r.experience_id === experienceId
  );
  if (experienceRule) return experienceRule.markup_percent;

  const providerRule = rules.find(
    (r) => r.provider_id === providerId && r.experience_id === null
  );
  if (providerRule) return providerRule.markup_percent;

  const globalRule = rules.find(
    (r) => r.provider_id === null && r.experience_id === null
  );
  return globalRule?.markup_percent ?? 30;
}
